<template>
  <v-container class="facility-reserve p-0" v-if="facilityType && settings" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="createdBooking ? $t('gym_booking.success_title') : facilityType.name.toUpperCase()"
                         :is-snap-content="true"
                         :is-sticky="true">
      <v-app-bar v-model="showFloatingInfo"
                 fixed
                 :class="['info-floating-header', {'d-none': !showFloatingInfo}]">
        <v-container>
          <v-row>
            <v-col class="text-left font-weight-bold">
              {{ facilityType.name }}
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>

      <v-app-bar v-model="showFloatingCategories"
                 fixed
                 :class="['category-floating-header', {'d-none': !showFloatingCategories}]"
                 :height="categoryHeight"
                 :style="floatCategoryStyle">
        <div class="overflow-x-auto scroll-wrapper">
          <div class="v-calendar v-calendar-daily v-calendar-category theme--light">
            <div class="v-calendar-daily__head">
              <div class="v-calendar-daily__intervals-head"></div>
              <div :class="['v-calendar-daily_head-day' , category.class]"
                   v-for="category in categories"
                   :key="category.day">
                <div class="v-calendar-daily_head-weekday">
                  {{ category.weekday }}
                </div>
                <div class="v-calendar-daily_head-day-label">
                  <button class="v-btn v-btn--depressed v-btn--fab v-btn--round theme--light v-size--default transparent">
                    <span class="v-btn__content">
                    {{ category.day }}
                  </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-app-bar>

      <v-row class="facility-reserve-content-row mb-3 pt-9 title-font"
             v-if="!createdBooking">
        <v-col class="availability-grid-col mx-0 mx-md-8 mx-lg-12 px-lg-12 px-md-8">
          <GymAvailabilityGrid :type-id="facilityType.id"
                               :from-date="today.toISODate()"
                               :to-date="sevenDaysAfter.toISODate()"
                               v-model="selectedDate"></GymAvailabilityGrid>
          <!--                    <AvailabilityGridOld :type-id="facilityType.id"-->
          <!--                                         :from-date="selectedWeekStart.toISODate()"-->
          <!--                                         :to-date="selectedWeekEnd.toISODate()"-->
          <!--                                         :available-from="minDate"-->
          <!--                                         :available-until="maxDate"-->
          <!--                                         :selected-time-slots="selectedTimeSlots"-->
          <!--                                         :max-session-length="settings.booking_limit_day"></AvailabilityGridOld>-->
        </v-col>
      </v-row>

      <v-row class="facility-reserve-steps py-2 px-2 py-md-6 px-md-6"
             v-if="!createdBooking">
        <v-col :class="$vuetify.breakpoint.width <= 600?'text-right':'text-right'"
               :cols="$vuetify.breakpoint.width <= 484 ? 12 : $vuetify.breakpoint.width <= 600?6:12">
          <v-btn color="primary" rounded
                 :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2"
                 :disabled="!selectedDate"
                 @click="confirmDialogShown = true">
            <span class="font-size-35">{{ $t('gym_booking.reserve') }}</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-container class="booking-confirm-content" fluid
                   v-if="createdBooking">
        <v-row>
          <v-col class="booking-confirm-title text-left">
            {{ $t('booking_confirm.summary') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field :label="$t('booking.reference_number')"
                          readonly
                          hide-details
                          :value="'GYM' + createdBooking.reference_number.toString().padStart(10, '0')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field :label="$t('gym_booking.date')"
                          readonly
                          hide-details
                          :value="$parseDate(createdBooking.date, 'yyyy-MM-dd')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn color="primary"
                   :to="{name: 'my-account', query: {t: 4}}">
              {{ $t('finish') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </HkiaraceBannerFrame>

    <v-dialog v-model="confirmDialogShown"
              content-class="confirm-dialog"
              max-width="320"
              persistent
              scrollable>
      <v-card>
        <v-card-title>{{ $t('gym_booking.reserve_title') }}</v-card-title>
        <v-card-text>{{ $t('gym_booking.reserve_msg') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
                 @click="confirmDialogShown = false">
            {{ $t('no') }}
          </v-btn>
          <v-btn text
                 color="rgb(142, 118, 91)"
                 @click="reserveGym">
            {{ $t('yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {DateTime} from 'luxon';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faCalendar, faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery'
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {computed, onBeforeUnmount, onMounted, ref} from '@vue/composition-api';
import GymAvailabilityGrid from "@/components/acc_booking/GymAvailabilityGrid";

library.add(faCalendar, faChevronLeft, faChevronRight);

export default {
  name: 'GymReserve',
  components: {GymAvailabilityGrid, HkiaraceBannerFrame},
  setup(props, {root}) {
    const settings = ref(null);
    const getSettings = function () {
      root.$callAPI('room/settings/', {}, function (response) {
        settings.value = response.body.settings;
      })
    };

    const facilityType = ref(null);

    // Floating Header
    const today = ref(DateTime.fromJSDate(new Date()));
    const sevenDaysAfter = computed(() => {
      return today.value.plus({days: 6});
    });

    const showFloatingInfo = ref(false);
    const showFloatingCategories = ref(false);
    const categories = computed(() => {
      let c = [];

      let d = DateTime.fromJSDate(new Date());

      while (d.startOf('day') <= sevenDaysAfter.value.endOf('day')) {
        c.push({
          day: d.toFormat('d'),
          weekday: d.toFormat('ccc'),
          class: 'v-present',
        });

        d = d.plus({day: 1});
      }

      return c;
    })
    const categoryHeaderX = ref(0);
    const categoryHeaderWidth = ref(0);
    const categoryHeight = ref(48);
    const floatCategoryStyle = computed(() => {
      return {
        left: `${categoryHeaderX.value + 1}px`,
        width: `${categoryHeaderWidth.value - 1}px`,
        top: `${(root.$vuetify.breakpoint.smAndDown ? 150 : 158)}px !important`,
      }
    })

    function onScroll(e) {
      let banner = $('.hkiarace-banner-frame-banner')[0];
      let bannerRect = banner.getBoundingClientRect();
      showFloatingInfo.value = bannerRect.bottom <= 160;


      let header = $('.availability-grid .v-calendar-daily__head')[0];
      if (header) {
        let availabilityGrid = $('.availability-grid')[0];

        let rect = header.getBoundingClientRect();
        showFloatingCategories.value = rect.top <= 150 && availabilityGrid.getBoundingClientRect().bottom >= 250;
        categoryHeight.value = rect.height;
        categoryHeaderX.value = rect.x;
        categoryHeaderWidth.value = rect.width;
      }
    }

    //
    const selectedDate = ref(null);
    const confirmDialogShown = ref(false);
    const reserveGym = function () {
      root.$callAPI('aafb/gym_booking/create/', {
        date: DateTime.fromFormat(selectedDate.value, 'yyyy-MM-dd').toISO(),
      }, (response) => {
        if (response.body.success) {
          createdBooking.value = response.body.booking;
          confirmDialogShown.value = false;
        }
      });
    }

    const createdBooking = ref(null);

    const getGymBookingStatus = function () {
      root.$callAPI('aafb/gym_booking/status/', {today: true}, (response) => {
        facilityType.value = response.body.type;
      });
    }

    onMounted(() => {
      getSettings();
      getGymBookingStatus();
      // getFacilityType();
      window.addEventListener('scroll', onScroll);
      window.addEventListener('resize', onScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    })

    return {
      facilityType,
      settings,

      today,
      sevenDaysAfter,

      showFloatingInfo,
      showFloatingCategories,
      categories,
      categoryHeight,
      floatCategoryStyle,

      selectedDate,
      confirmDialogShown,
      reserveGym,

      createdBooking,
    }
  },
}
</script>

<style lang="less">
.facility-dialog {
  width: auto;
  min-width: 40vw;
  max-width: 80vw;
}

.facility-reserve {

  .datepicker-calendar {
    width: 100%;
    border: none;
    margin: auto;

    .selected {
      background: #cae5ed !important;
    }
  }

  .facility-reserve-content-row {
    background-color: white;

    text-transform: uppercase;

    .availability-grid-col {
      /*overflow: scroll;*/
      /*max-width: 750px;*/
      margin: auto;

      .availability-grid-legend {

      }
    }
  }

  .facility-reserve-steps {
    .v-avatar {
      margin-right: 12px;
    }

    .mdi-arrow-right {
      margin-left: 24px;
      margin-right: 12px;
    }
  }

  .booking-confirm-content {
    max-width: 1000px;
    background-color: white;
    padding: 2rem;

    .booking-confirm-title {
      color: #8E765B;
      font-size: 1.5em !important;
    }

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }
}

.quick-checkout-btn {
  color: black !important;
}


#choiceSelector {
  .custom-radio {
    margin-bottom: 30px;
  }
}

.info-floating-header {
  top: 94px !important;
  z-index: 4 !important;
  background-color: white !important;
}

.category-floating-header {
  font-family: 'Montserrat', Roboto, "PingFang TC", "Heiti TC", "\5FAE\8EDF\6B63\9ED1\9AD4", "Microsoft JhengHei", "sans-serif" !important;
  background-color: transparent !important;
  box-shadow: none !important;
  transition: none;
  z-index: 4 !important;

  .scroll-wrapper {
    width: 100%;
  }

  .v-toolbar__content {
    background-color: transparent;
    padding: 0;
  }

  .v-calendar {
    border-left: none !important;
  }

  .v-calendar-daily__head {
    margin-right: 0;
    border-left: none !important;

    .v-calendar-daily__intervals-head {
      width: 45px;
      border-left: none !important;
    }
  }

  .v-calendar-daily_head-day:last-child {
    border-right: none !important;
  }

  .v-calendar-daily__intervals-body {
    border-right: none !important;
  }

  .v-calendar-daily__day {
    border-right: none !important;
    border-bottom: none !important;

    &:last-child {
      border-right: none !important;
    }
  }

  .v-btn--fab.v-size--default {
    height: initial;
    width: initial;
  }
}
</style>
